/*
 * File: /src/router/routes/callResults.js
 * Created Date: Wednesday November 6th 2024
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Wednesday, 6th November 2024 9:32:35 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2024 AdBase, Inc.
 */

const CallResultTypes = () =>
  import(/* webpackChunkName: "CallResultType" */ 'src/components/Dashboard/Views/CallResultTypes/CallResultTypeList.vue');

const EditCallResultType = () =>
  import(/* webpackChunkName: "CallResultType" */ 'src/components/Dashboard/Views/CallResultTypes/CallResultTypeEdit.vue');

export const callResultTypeRoutes = [
  {
    path: 'call-result-types/',
    name: 'Call Result Types',
    component: CallResultTypes
  },
  {
    path: 'call-result-types/add',
    name: 'Add New Call Result Type',
    component: EditCallResultType
  },
  {
    path: 'call-result-types/edit/:id',
    name: 'Edit Call Result Type',
    component: EditCallResultType
  }
];

